import Head from "next/head";
import { CampaignEnd } from "../../../component/organism";

const End = () => {
  return (
    <>
      <Head>
        <title>
          キャンペーン終了のお知らせ |
          オフサイトミーティングを一括手配：コワーケーション.com
        </title>
        <meta
          name="keywords"
          content="キャンペーン,コワーケーション,合宿,研修,オフサイトミーティング,チームビルディング,役員合宿,"
        />
        <meta
          name="description"
          content="法人の経営合宿やチームビルディング合宿、オフサイトミーティングのために、全国の施設と研修・体験コンテンツを代行して一括手配するコワーケーション.com。本キャンペーンは終了いたしました。"
        />
      </Head>
      <CampaignEnd />
    </>
  );
};

export default End;
